var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSessionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5002 25.375V15.7083M14.5002 25.375L5.7735 19.9208C5.31397 19.6336 5.08421 19.49 4.95885 19.2639C4.8335 19.0377 4.8335 18.7667 4.8335 18.2248V9.66667M14.5002 25.375L19.3335 22.3542L23.2268 19.9208C23.6864 19.6336 23.9161 19.49 24.0415 19.2639C24.1668 19.0377 24.1668 18.7667 24.1668 18.2248V9.66667M14.5002 15.7083L4.8335 9.66667M14.5002 15.7083L24.1668 9.66667M4.8335 9.66667L13.4402 4.2875C13.9556 3.96533 14.2134 3.80425 14.5002 3.80425C14.787 3.80425 15.0447 3.96533 15.5602 4.2875L24.1668 9.66667",
    stroke: "#AFAFAF",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3332 17.5195C18.3332 18.0718 18.7809 18.5195 19.3332 18.5195C19.8855 18.5195 20.3332 18.0718 20.3332 17.5195H18.3332ZM18.3932 12.0987L17.8632 12.9467L18.3932 12.0987ZM19.2078 12.7557L20.0825 12.2709L19.2078 12.7557ZM9.1365 7.49253L17.8632 12.9467L18.9232 11.2507L10.1965 5.79653L9.1365 7.49253ZM20.3332 17.5195V13.7947H18.3332V17.5195H20.3332ZM17.8632 12.9467C18.1089 13.1003 18.2335 13.1794 18.3174 13.2437C18.3844 13.2951 18.3602 13.2891 18.3332 13.2404L20.0825 12.2709C19.9301 11.996 19.7283 11.8052 19.5342 11.6564C19.357 11.5206 19.137 11.3843 18.9232 11.2507L17.8632 12.9467ZM20.3332 13.7947C20.3332 13.5426 20.3342 13.2838 20.313 13.0615C20.2897 12.8181 20.2348 12.5458 20.0825 12.2709L18.3332 13.2404C18.3062 13.1918 18.314 13.168 18.322 13.2521C18.3321 13.3573 18.3332 13.5049 18.3332 13.7947H20.3332Z",
    fill: "#AFAFAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessionIcon);
export default __webpack_public_path__ + "static/media/session-icon.44cc4da245ea3b570a62c3abb9fb3994.svg";
export { ForwardRef as ReactComponent };